(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rdtn-bundle-panel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rdtn-bundle-panel')) {
    customElements.define('rdtn-bundle-panel', class extends HTMLElement {
      connectedCallback() {
        this.observer?.disconnect();
        const refresh = () => {
          this.classList.toggle('rdtn-bundle--ready', Boolean(this.querySelector('.Avada-Fbt, .Avada-Bundle-Offer__Volume > *')));
        };
        this.observer = new MutationObserver(refresh);
        this.observer.observe(this, { childList: true, subtree: true });
        refresh();
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
